import { Star } from "@phosphor-icons/react";
import { cn } from "@/lib/cn";

export type StarFill = "full" | "half" | "empty";

export function starFills(rating: number): StarFill[] {
  const value = Math.max(0, Math.min(5, rating));
  return Array.from({ length: 5 }, (_, index) => {
    const remainder = value - index;
    if (remainder >= 0.75) return "full";
    if (remainder >= 0.5) return "half";
    return "empty";
  });
}

export function RatingStars({ rating, count, summary = false }: { rating: number; count?: number; summary?: boolean }) {
  if (summary) {
    return (
      <span className="inline-flex shrink-0 items-center gap-1 text-caption text-text-secondary tnum" aria-label={`${rating} out of 5 stars${count === undefined ? "" : `, ${count} ratings`}`}>
        <Star className="size-3 fill-current text-warning" weight="fill" aria-hidden="true" />
        <span>{rating.toFixed(1)}</span>
        {count !== undefined && <span>({count})</span>}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 text-caption text-text-secondary tnum" aria-label={`${rating} out of 5 stars${count === undefined ? "" : `, ${count} ratings`}`}>
      <span className="inline-flex gap-0.5 text-warning" aria-hidden="true">
        {starFills(rating).map((fill, index) => (
          <span key={index} className="relative size-3.5">
            <Star className={cn("absolute size-3.5", fill === "full" ? "fill-current" : "fill-transparent", fill === "empty" && "text-border-strong")} weight="regular" />
            {fill === "half" && <span className="absolute inset-0 w-1/2 overflow-hidden"><Star className="size-3.5 fill-current" weight="regular" /></span>}
          </span>
        ))}
      </span>
      <span>{rating.toFixed(1)}</span>
      {count !== undefined && <span>({count})</span>}
    </span>
  );
}
